import { SustainabilityQuestion } from '@hb/domain';
import { SustainabilityStoreService } from '@hb/modules/property/sustainability/sustainability-store.service';
import { SustainabilityLoanComponent } from '@hb/modules/property/sustainability/sustainability-loan/sustainability-loan.component';
import { SustainabilityAmountComponent } from '@hb/modules/property/sustainability/sustainability-amount/sustainability-amount.component';
import { PreviousButtonComponent } from '@hb/modules/global/button';

import { Subscription } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';

@Component({
    selector: 'sustainability',
    templateUrl: './sustainability.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        ApRadioModule,
        PreviousButtonComponent,
        SustainabilityLoanComponent,
        SustainabilityAmountComponent
    ]
})
export class SustainabilityComponent implements OnInit, OnDestroy {
    protected readonly store = inject(SustainabilityStoreService);

    private activeQuestion: SustainabilityQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy(): void {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showSustainabilityLoan(): boolean {
        return (
            this.activeQuestion === SustainabilityQuestion.SUSTAINABILITY_LOAN_BUTTON ||
            (this.store.isActiveQuestion(SustainabilityQuestion.SUSTAINABILITY_LOAN_BUTTON) && this.store.isSummary)
        );
    }
    showSustainabilityAmount(): boolean {
        return (
            (this.activeQuestion === SustainabilityQuestion.SUSTAINABILITY_AMOUNT && !this.store.isSummary) ||
            (this.store.isActiveQuestion(SustainabilityQuestion.SUSTAINABILITY_AMOUNT) && this.store.isSummary)
        );
    }
}
